<template>
  <InfuseDescriptionList :rows="rows" :item="item" :loading="loading">
    <template #date="{ data }">
      {{ formatDate(data) }}
    </template>

    <template #chargePointName="{ data }">
      <i>{{ data }}</i>
    </template>

    <template #centralSystemName="{ data }">
      <i>{{ data }}</i>
    </template>
  </InfuseDescriptionList>
</template>

<script lang="ts" setup>
import { InfuseDescriptionList } from '@infuse/ui/components';
import { UiDescriptionListRow } from '@infuse/ui/domain';
import { computed, ComputedRef } from 'vue';
import { useI18n } from 'vue-i18n';
import { Message } from '@infuse/e-connector/message/domain';
import { formatDate } from '@infuse/ui/utils';

interface Props {
  item: Message;
  loading?: boolean;
}

withDefaults(defineProps<Props>(), {
  loading: false
});

const { t } = useI18n();

const rows: ComputedRef<UiDescriptionListRow[]> = computed(() => [
  {
    name: 'chargePointName',
    term: t('e_connector.common.message.chargePointName'),
    detailField: 'chargePointName'
  },
  {
    name: 'centralSystemName',
    term: t('e_connector.common.message.centralSystemName'),
    detailField: 'centralSystemName'
  },
  {
    name: 'messageType',
    term: t('e_connector.common.message.messageType'),
    detailField: 'messageType'
  },
  {
    name: 'messageAction',
    term: t('e_connector.common.message.messageAction'),
    detailField: 'messageAction'
  },
  {
    name: 'date',
    term: t('e_connector.common.message.date'),
    detailField: 'date'
  }
]);
</script>
